import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormInput from 'components/forms/FormInput';

class LeadTaggerData extends EntityPropsUpdater {
  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;

    return (
      <div className="clearfix">
        {entityLoaded && (
          <div>
            <Row>
              <Col xs={12} md={inModal ? 12 : 6}>
                <div className="panel panel-transparent">
                  <div className="panel-body">
                    <p className="form-group-title">{messages.formGroup.basic_information}</p>
                    <div className="form-group-attached">
                      <FormInput
                        name="name"
                        label={messages.name}
                        value={entity.getName()}
                        meta={entity.getNameMetaInformation()}
                        validation={entity.getNameValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        name="tag"
                        label="Tag"
                        value={entity.getTag()}
                        meta={entity.getTagMetaInformation()}
                        validation={entity.getTagValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        name="pattern"
                        label="Pattern"
                        value={entity.getPattern()}
                        meta={entity.getPatternMetaInformation()}
                        validation={entity.getPatternValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                        prefixAddon="/"
                        suffixAddon={'/' + entity.getFlags()}
                      />
                      <FormInput
                        name="flags"
                        label="Flags"
                        value={entity.getFlags()}
                        meta={entity.getFlagsMetaInformation()}
                        validation={entity.getFlagsValidationResult()}
                        onChange={this.updateEntity}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  }
}
LeadTaggerData.defaultProps = {
  inModal: false,
};

export default injectIntl(LeadTaggerData);
